module.exports = __webpack_public_path__ + "img/28_8.b046c392.png";